import type { FeatureBlockContent, HeroContent } from './types';

export const businessHero: HeroContent = {
  title: 'The all-in-one platform for your global business',
  cta: {
    label: 'Register',
    href: 'https://nsave.business/registration',
    external: true,
  },
  secondaryCta: {
    label: 'Sign in',
    href: 'https://nsave.business/login',
    external: true,
  },
  image: {
    src: '/images/business/hero.jpg',
    width: 2099,
    height: 1200,
    alt: 'nsave business dashboard showing a USD balance and transactions on a desktop monitor in a warm office',
  },
};

export const businessReceive: FeatureBlockContent = {
  title: 'Receive global payments',
  image: {
    src: '/images/business/receive.jpg',
    alt: 'nsave multi-currency account showing USD, GBP and EUR balances beside a red notebook',
  },
  rows: [
    {
      icon: 'flag-usd',
      title: 'USD Transfers',
      description:
        'Get your own ACH and Wire details and receive payments from employers, clients and platforms in USD.',
    },
    {
      icon: 'flag-gbp',
      title: 'GBP Transfers',
      description:
        'Get paid by UK companies and clients quickly and reliably, via wire or faster payments (FPS).',
    },
    {
      icon: 'flag-eur',
      title: 'EUR Transfers',
      description:
        'Receive EUR payments with your own IBAN over SEPA. Accept salaries, invoices and transfers from across Europe.',
    },
  ],
};

export const businessInvoices: FeatureBlockContent = {
  title: 'Pay your invoices',
  image: {
    src: '/images/business/invoices.jpg',
    alt: 'A red notebook on grid paper with a pencil, ready for bookkeeping and invoices',
  },
  rows: [
    {
      icon: 'swap',
      title: 'Convert between your USD, GBP & EUR accounts',
      description: 'Switch between your balances instantly, whenever the rate suits you.',
    },
    {
      icon: 'clock',
      title: '24/7 Conversion',
      description: 'Convert any time, day or night, even when the markets are closed.',
    },
    {
      icon: 'percent',
      title: 'Great rates, low fees',
      description: 'The real exchange rate with one transparent fee and no hidden spread.',
    },
  ],
};

export const businessPayTeam: FeatureBlockContent = {
  title: 'Pay your team',
  image: {
    src: '/images/business/pay-team.jpg',
    alt: 'A focused professional working at a computer, managing payroll for their team',
  },
  rows: [
    {
      icon: 'users',
      title: 'Run payroll',
      description: 'Pay your team, whether to their local bank accounts or nsave accounts.',
    },
    {
      icon: 'at-sign',
      title: "Send to your team's nsave accounts",
      description:
        'Get your global team set up with nsave and easily pay them at zero fees with their @ntags.',
    },
  ],
};
